module.exports = __webpack_public_path__ + "static/img/chuo.43ecb64d.png";